import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { GET_CUSTOMERS_QUERY_KEY } from '~/features/customers/hooks/useGetCustomers'
import { useNotifyError } from '~/features/hooks/useNotifyError'
import { supabaseApi } from '~/supabase/api'

export const useDeleteCustomers = () => {
  const queryClient = useQueryClient()

  const { mutate: notifyError } = useNotifyError()

  return useMutation({
    mutationKey: ['delete-customers'] as const,
    mutationFn: async (ids: number[]) => {
      await Promise.all(
        ids.map(async (id) => {
          const { error } = await supabaseApi.from('customers').delete().eq('id', id)

          if (error) {
            toast.error('Customer could not be deleted')
            notifyError({
              data: { id },
              error,
              message: 'Customer could not be deleted',
              function: 'useDeleteCustomers',
            })

            throw error
          }
        })
      )
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_CUSTOMERS_QUERY_KEY] })
      toast.success('Customer successfully deleted')
    },
  })
}
